









import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import router from "../router";
import { LooseObject } from "../types";
@Component
export default class Search extends Vue {
  public $refs!: {
    search: HTMLInputElement;
  };
  //  issearching:boolean = false;
  searchString: string = "";
  @Prop() global!: boolean;
  @Prop() content!: boolean;
  @Getter lastPage!: string;
  @Getter issearching!: boolean;
  updateSearchString($event: any) {
    //     this.searchString = $event.target.value.length > 2 ? $event.target.value : '';
    this.searchString = $event.target.value;
    if (this.global) {
      if (this.searchString === "") {
        //      let goto: LooseObject;
        /*  if (this.$store.state.page === "search"){
        }*/
        //TODO: error, wenn startseite auf suchseite ist
        this.$router.push(this.$store.state.page);

        //  this.$router.go(-this.$store.state.lastPage);
        //  this.$store.commit("currentPage", false);
      } else {
        this.setCurrentPage();
        this.$router.push({
          name: "search",
          params: { search: this.searchString }
        });
      }
    } else {
      this.$emit("updateSearchString", this.searchString);
    }
  }
  setCurrentPage() {
    if (this.$router.currentRoute.name != "search") {
      if (this.$refs.search.value != "") {
        this.searchString = this.$refs.search.value;
        this.$router.push({ path: `/s/${this.searchString}` });
      } else {
        if (this.$router.currentRoute.name === "book") {
          if (!this.$store.state.page.name) {
            this.$store.commit("setCurrentPage", { name: "home" });
          }
        } else {
          this.$store.commit("setCurrentPage", this.$router.currentRoute);
        }
      }
    } else {
      this.$refs.search.value = this.$route.params.search;
    }
  }
  activate() {
    this.$refs.search.focus();
  }
  focus() {
    this.issearching = true;
  }
  mounted() {
    if (this.global) {
      this.$refs.search.addEventListener("focusin", () => {
        this.setCurrentPage();
      });
      this.$refs.search.addEventListener("focusout", () => {
        this.$store.commit("searching", false);
      });
    }
    this.$refs.search.focus();
  }
}
